import request from "../requests";
export default {
  // 网站基本信息-网站基本信息查询
  getFooterInfo: () => request.get("/api/business/base/info/v2"),
  // 网站导航栏目模块-查询栏目列表
  getNavList: (navType, parentId) =>
    request.get("/api/business/nav/list", {
      params: {
        navType: navType,
        parentId: parentId,
      },
    }),
  // 文章模块-查询文章列表，id,当前页，每页条数，发布状态0-未发布 1-已发布
  getArticle: (navId, pageNum, pageSize, releaseStatus, title, year, navName) =>
    request.get("/api/business/article/list", {
      params: {
        navId: navId,
        pageNum: pageNum,
        pageSize: pageSize,
        releaseStatus: releaseStatus,
        title: title,
        year: year,
        navName: navName,
      },
    }),
    getArticle1: (navId, pageNum, pageSize, releaseStatus, navName) =>
      request.get("/api/business/article/list", {
        params: {
          navId: navId,
          pageNum: pageNum,
          pageSize: pageSize,
          releaseStatus: releaseStatus,
          navName: navName,
        },
      }),
  specialGetArticle: (pageNum, pageSize, releaseStatus, navName) =>
    request.get("/api/business/article/list", {
      params: {
        pageNum: pageNum,
        pageSize: pageSize,
        releaseStatus: releaseStatus,
        navName: navName,
      },
    }),
  getWeiImgLists: (navId) =>
    request.get("/api/business/article/lj/list", {
      params: {
        navId,
      },
    }),
  // 获取精彩照片
  getPic: (navName, pageNum, pageSize) =>
    request.get("/api/business/article/list", {
      params: {
        navName: navName,
        pageNum: pageNum,
        pageSize: pageSize,
      },
    }),
  // 获取地方动态
  getPlace: (cityName) =>
    request.get("/api/business/article/list", {
      params: {
        cityName: cityName,
      },
    }),
  // 获取文章详细信息
  getArticleDesc: (id) =>
    request.get("/api/business/article/desc", {
      params: {
        id: id,
      },
    }),
  // 轮播图
  // getSliders: (position) => request.get('/api/business/ad/list', {
  //     params: {
  //         'position': position
  //     }
  // }),
  // 查询公告列表
  getNoticeList: (pageNum, pageSize) =>
    request.get("/api/business/notice/list", {
      params: {
        pageNum: pageNum,
        pageSize: pageSize,
      },
    }),
  // 查询公告详细信息
  getNoticedesc: (id) =>
    request.get("/api/business/notice/desc", {
      params: {
        id: id,
      },
    }),
  // 大事件年份列表
  getYear: () => request.get("/api/business/article/memorabilia"),
  // 社内互动
  getshenei: (navName) =>
    request.get("/api/business/nav/list/byName", {
      params: {
        navName: navName,
      },
    }),
  // 专题专栏（6个小的）
  getSpecial: () => request.get("/api/business/nav/list/special"),
  // 专委会
  getCommittee: (navName, navType) =>
    request.get("/api/business/nav/list", {
      params: {
        navName: navName,
        navType: navType,
      },
    }),
  // 获取轮播图
  getSliders: () => request.get("/api/business/ad/list/v2"),
  getJiGou: () => request.get("/api/business/ad/list/jiGou"),
  // 获取特有文章
  getSpecific: (title) =>
    request.get("/api/business/article/specific", {
      params: {
        title: title,
      },
    }),
  // 电子期刊
  getEBook: () => request.get("/api/business/journal/list"),
  // 查询电子期刊详情
  getEBookDesc: (id) =>
    request.get("/api/business/journal/desc", {
      params: {
        id: id,
      },
    }),
  // 网站顶部和专题专栏的图片
  getBannerPic: (position) =>
    request.get("/api/business/ad/list", {
      params: {
        position,
      },
    }),
  // 首页6小块专题专栏（解决三级文章上传首页显示、首页加载速度的问题）
  getSpecialColumn: (id) =>
    request.get("/api/business/article/two/nav/list", {
      params: {
        id: id,
      },
    }),
  // 发送电子邮件
  sendEmail: (data) =>
    request.post("/api/email/customer/sendSimpleEmail", data),
  // 获取验证码
  getCode: (data) => request.get("/api/captchaImage/char"),
  // 后台获取访问量
  loginInfoAdd: (data) => request.post("/api/business/logininfo/add", data),
};
